import { Box, Button, Tab, Tabs } from '@mui/material';
import { useState, FC, useRef, useEffect } from 'react';
import styles from './InsuranceContractPage.module.css';
import React from 'react';
import { CustomTabPanel } from '../../shared/custom-tab-panel/custom-tab-panel';
import { useLocation, useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import MainInfo from 'features/contract-page/ui/MainInfo';
import { PaymentSchedule } from 'features/contract-page/ui/PaymentSchedule';
import { useAppSelector } from 'shared/utils/hooks/useRedux';
import { CaseMainInfo } from 'entities/insurance-contract/main-info/selector';
import InsuranceProgramsCase from 'features/contract-page/ui/InsuranceProgramsCase';
import InsuredPersonsCase from 'features/contract-page/ui/InsuredPersonsCase';
import TasksCase from 'features/contract-page/ui/TasksCase';

import appStyles from 'app/providers/theme/App.module.css';
import { SpecialPogram } from 'features/contract-page/ui/SpecialPogram';

export const InsuranceContractPage: FC = () => {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const mainInfoData = useAppSelector(CaseMainInfo);
    const query = useQuery();
    const idCase = query.get('id');
    const [value, setValue] = React.useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    const a11yProps = (index: number) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const [loading, setLoading] = useState(false);

    const handleClickBack = () => {
        navigate('/insurance-contracts', {
            state: {
                textRout: 'insurance-contracts',
                name: 'Договоры страхования'
            }
        });
    };

    const tabsRef = useRef<HTMLDivElement>(null);
    const handleWheel = (event: React.WheelEvent) => {
        if (tabsRef.current) {
            const tabsContainer = tabsRef.current.querySelector('.MuiTabs-scroller');
            if (tabsContainer) {
                tabsContainer.scrollLeft += event.deltaY * 4;
            }
        }
    };

    useEffect(() => {
        if (location.state?.activeTab !== undefined) {
            setValue(location.state.activeTab);
        }
    }, [location.state]);

    return (
        <>
            <Box className={appStyles.titleBox}>
                <h1>Договор страхования <span>{mainInfoData ? mainInfoData.Number : ''}</span></h1>
                <Box className={appStyles.titleBtn}>
                    <Button onClick={handleClickBack} className={appStyles.btnBack}><KeyboardBackspaceIcon /> Назад к списку договоров</Button>
                </Box>
            </Box>
            <Box onWheel={handleWheel} ref={tabsRef} className={styles.tabsBox}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#0054E6'
                        },
                    }}
                >
                    <Tab
                        label="Данные договора"
                        {...a11yProps(0)}
                        sx={{
                            '&.Mui-selected': {
                                color: '#0054E6 !important',
                            },
                        }}
                    />
                    <Tab
                        label="График платежей"
                        {...a11yProps(1)}
                        sx={{
                            '&.Mui-selected': {
                                color: '#0054E6 !important',
                            },
                        }}
                    />

                    <Tab
                        label="Заявки"
                        {...a11yProps(2)}
                        sx={{
                            '&.Mui-selected': {
                                color: '#0054E6 !important',
                            },
                        }}
                    />

                    <Tab
                        label="Программы страхования"
                        {...a11yProps(3)}
                        sx={{
                            '&.Mui-selected': {
                                color: '#0054E6 !important',
                            },
                        }}
                    />
                    <Tab
                        label="Список застрахованных"
                        {...a11yProps(4)}
                        sx={{
                            '&.Mui-selected': {
                                color: '#0054E6 !important',
                            },
                        }}
                    />
                    {mainInfoData.HasSpecialProgramData && (
                        <Tab
                            label="Спец. программа"
                            {...a11yProps(5)}
                            sx={{
                                '&.Mui-selected': {
                                    color: '#0054E6 !important',
                                },
                            }}
                        />
                    )}
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
                <MainInfo
                    idCase={idCase ? idCase : ''}
                />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
                <PaymentSchedule
                    idCase={idCase ? idCase : ''}
                    setLoading={setLoading}
                />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={2}>
                <TasksCase
                    idContract={idCase ? [idCase] : []}
                />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={3}>
                <InsuranceProgramsCase
                    idContract={idCase ? [idCase] : []}
                />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={4}>
                <InsuredPersonsCase
                    idContract={idCase ? [idCase] : []}
                />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={5}>
                <SpecialPogram
                    idCase={idCase ? idCase : ''}
                />
            </CustomTabPanel>
        </>
    );
};

export default InsuranceContractPage;
